import { useCallback, useState } from 'react';

export type Theme = 'light' | 'dark';

const read = (): Theme => (document.documentElement.classList.contains('dark') ? 'dark' : 'light');

/** Light/dark: starts from the phone's setting (index.html); a choice is remembered on this device. */
export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(read);
  const toggle = useCallback(() => {
    const next: Theme = read() === 'dark' ? 'light' : 'dark';
    document.documentElement.classList.toggle('dark', next === 'dark');
    try {
      localStorage.setItem('jv.theme', next);
    } catch {}
    for (const m of document.querySelectorAll('meta[name="theme-color"]'))
      m.setAttribute('content', next === 'dark' ? '#111316' : '#F2F3EF');
    setTheme(next);
  }, []);
  return [theme, toggle];
}
